import { AlertSuccess, AlertError } from '../alerts';
import { FC } from 'react';
import { Box } from '@chakra-ui/react'

export const FormAlert: FC<any> = ({ success, error }) => {
  if (!success && !error) return null;

  return (
    <Box>
      {success && <AlertSuccess message={success} />}
      {error && <AlertError message={error} />}
    </Box>
  )
}
